import React, { FC, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Container } from './Container';

interface SkeletonProps {
  height: string;
}
interface SkeletonWrapProps {
  height: string;
  isSticky?: boolean;
}

const waves = keyframes`
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
`;
const StyleSkeleton = styled.div<SkeletonProps>`
  ${({ height }) => css`
    width: 100%;
    height: ${height};
    margin-bottom: 6px;
    border-radius: 2px;
    background: rgba(238, 238, 238, 0.2);
    background: linear-gradient(to right, #f2f0f0 8%, #e6e6e6 18%, #f2f0f0 33%);
    background-size: 800px 100px;
    animation: ${waves} 2s infinite ease-out;
  `}
`;
export const StyleSkeletonOverlay = styled(Container)<SkeletonWrapProps>`
  ${({ theme: { layers, space }, height, isSticky }) => css`
    width: 100%;
    height: ${height};
    position: absolute;
    top: ${isSticky ? space.md : 'auto'};
    left: 0;
    right: 0;
    z-index: ${layers.stickyBar};
  `}
`;

export const Skeleton: FC<SkeletonProps> = ({ height = '32px' }) => <StyleSkeleton height={height} />;
